import React from 'react';
import { noop } from 'lodash';

export const AdminPagePickerContext = React.createContext({
  open: noop,
  close: noop,
});
